<template>
  <div class="task-config-general">

    <el-form :model="taskClone" @submit.native.prevent v-if="taskClone">

      <span style="font-size: 9pt; color: gray; float: right;">
        Create at: {{taskClone.createdAt}}
      </span>

      <el-checkbox v-model="taskClone.done" label="Done" border></el-checkbox>

      <div class="sub-title">Name:</div>
      <el-input placeholder="Please input" v-model="taskClone.name" class="inline-input"></el-input>

      <div class="sub-title">Description:</div>
      <el-input type="textarea" v-model="taskClone.description"></el-input>

      <!--<div class="sub-title">Relative Importance:</div>
      <el-slider v-model="taskClone.size" show-input></el-slider>-->

      <!--<div class="sub-title">Total Duration in minutes</div>
      <el-slider v-model="taskClone.duration" show-input :min="taskClone.durationRemaining" :max="8*60" :step="10"></el-slider>
      <div>Duration: {{taskClone.duration}}
      </div>

      <div class="sub-title">Remaining Duration in minutes</div>
      <el-slider v-model="taskClone.durationRemaining" show-input :min="0" :max="8*60" :step="10"></el-slider>
      <div>
        Duration: {{taskClone.durationRemaining}}
      </div>-->

      <div class="sub-title">Deadline</div>
      <date-selector
       v-model="taskClone.deadline"
       type="date"
       placeholder="Pick a day">
     </date-selector>

      <div class="sub-title">Fun factor <!--&#x1F603;--></div>
      <div style="margin-top: 20px" class="fun-factor">
       <el-radio-group v-model="taskClone.userMood">
         <el-radio-button
           v-for="(emoji, index) in emojiMoodList"
           :key="'emoji-'+index"
           :value="index"
           :label="emoji">
         </el-radio-button>
       </el-radio-group>
      </div>
      <!--
      <div @click="onRemoveTask(task.$id)">
        <font-awesome-icon size="lg" icon="trash" />
      </div>
      -->
      <!-- <pre>{{taskClone}} userMood: {{userMood}}</pre> -->

      <!--
      <div class="form-title">Goal name:</div>
      <el-input
        :disabled="!currentUserIsAdmin"
        placeholder="Your new goal..."
        v-model="taskClone.name"
        class="inline-input"
        autocomplete="off"
        autofocus />

      <div class="form-title">Description:</div>
      <el-input :disabled="!currentUserIsAdmin" type="textarea" v-model="taskClone.description"></el-input>

      <div class="form-title">Goal type:</div>
      <div class="pt-4 pb-4">
        <el-switch
          :disabled="!currentUserIsAdmin"
          v-model="taskClone.isTeamgoal"
          active-text="Team Goal"
          inactive-text="Private Goal"></el-switch>
      </div>

      <div class="form-title">Image:</div>
      <ImageUpload v-model="taskClone.picture" bucket="task_attachments/$teamId" />

      <div class="form-title">Rules:</div>
      <el-input
        type="textarea"
        v-model="taskClone.rules"
        :disabled="!currentUserIsAdmin"></el-input>
      -->

      <el-alert v-if="user_input_error" type="error">Error: Invalid input <!-- TODO more details --></el-alert>
      <el-row style="margin-top: 1em">
        <el-button type="primary" @click="onSaveSettings">Save settings</el-button>
        <el-button type="danger" @click="onDeleteTask" style="float: right">Delete Task</el-button>
      </el-row>
    </el-form>

    <!--
    <span slot="footer" class="dialog-footer">
      <el-button @click="taskCloneVisible = false">Close</el-button>
    </span>
    -->

    <!--
    <el-dialog
      v-if="taskModalOpen"
      :visible.sync="taskModalOpen"
      title="Goal settings"
      class="filtered">
      onSaveModal
    </el-dialgo>
    -->

    <!--
    <el-row>
      <el-col :span="12">
        <div class="sub-title">Task type:</div>
        <el-switch
          v-model="taskClone.isTemplate"
          active-text="Template task"
          inactive-text="Single task">
        </el-switch>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <div class="sub-title">Daily Task:</div>
        <el-checkbox v-model="taskClone.isDaily" label="Is Daily" border></el-checkbox>
      </el-col>
      <el-col :span="12">
        <div class="sub-title">Daily at fixed time:</div>
        TODO: this component can not handle user timezone
        <el-time-select
          v-model="taskClone.dailyAtFixedTime"
          :disabled="!taskClone.isDaily"
          :picker-options="{
            start: '08:30',
            step: '00:30',
            end: '18:30'
          }"
          placeholder="Select time">
        </el-time-select>
      </el-col>
    </el-row>
    -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    isNewTask: {},
    goalId: { required: true }, // required?
    memberId: {},
    taskId: {},
  },
  data: () => ({
    taskClone: null,
    user_input_error: false,
    emojiMoodList: {
      '1': '😦', // &#x1F60A;
      '2': '😐', // &#x1F610;
      '3': '🙂', // &#x1F62C;
      '4': '🕺',
    },
  }),
  mounted() {
    this.taskClone = this.$models.taskMeta.with({ goalId: this.goalId, uid: this.memberId }).getNode( this.taskId ).clone();
    this.taskClone.setValidationBehaviour('ELEMENT_VALIDATION')
    console.log("[GeneralSettingsPage] This instance will be used for editing", this.taskClone);

    // this.cloneTask();
  },
  computed: {
    ...mapGetters("user", [
      "userAuth"
    ]),

    task_meta() {
      return this.$models.taskMeta.with({ goalId: this.goalId, uid: this.memberId }).getNode( this.taskId );
    },

    /* TODO: Move to model getter */
    currentUserIsAdmin() {
      /*
      let members = this.task_meta.members;
      if ( this.userAuth.id in members && members[this.userAuth.id] ) {
        return members[this.userAuth.id].isAdmin;
      }
      return false;
      */
      return true // TODO
    },
  },
  methods: {
    // -------------------------------------------------------------------------

    // onEditGoal(task_id) {
    //   this.cloneTask();
    //   this.taskModalOpen = true;
    // },

    onSaveSettings() {
      console.log("onSaveModal", this.taskClone);

      if ( !this.taskClone.deadline ) {
        this.taskClone.deadline = null;
      } else {
        this.taskClone.deadline = this.taskClone.deadline.toRealtimeDB();
      }

      if ( !this.taskClone.$isValid() ) {
        this.user_input_error = true;
        this.user_input_invalid_list = Object.keys(this.taskClone.$invalid);
      } else {
        this.taskClone.write();
        this.user_input_error = false;
      }
    },

    onDeleteTask() {
      console.log("TODO");
    },

    // cloneTask() {
    //   // this.taskClone = this.task;
    //   // this.taskClone = Object.assign({}, this.task);
    //
    //   this.taskClone = this.$models.taskMeta // .taskDetails
    //     .with({ goalId: this.goal_id })
    //     .getNode( this.task.$id )
    //     .clone()
    //
    //   // if ( this.taskClone.deadline ) {
    //   //   /* Always convert 'Timestamp' to 'Date' */
    //   //   this.taskClone.deadline = this.taskClone.deadline.toDate();
    //   // }
    // },
  },
  components: {
  }
}
</script>

<style>
.task-config-general .form-title {
  font-weight: bold;
  margin-top: 0.8em;
  margin-bottom: 0.4em;
}
</style>
